import { formConvertErrorMessage } from "helpers/form_helper";
import { errorMessage } from "helpers/utils";
import { useTranslation } from "react-i18next";
import { useMutation, useQuery } from "react-query";
import { useToasts } from "react-toast-notifications";
import timeslotCollectorService from "services/timeslotCollectorService";

export const useTimeslotCollectorList = (payload, onSuccess, onError) => {
  const { enabled, params } = payload;
  return useQuery(
    ["timeslot-collector-list", params],
    () => timeslotCollectorService.getTimeslotCollectorList(params),
    {
      enabled: enabled || false,
      retry: 1,
      refetchOnWindowFocus: false,
      onSuccess,
      onError,
      initialData: Object({ data: {} }),
      select: response => {
        const { data } = response;
        return {
          items: data.items || [],
          params: params,
          meta: data._meta,
        };
      },
    }
  );
};

export const useCreateTimeslotCollector = (onSuccess, onError) => {
  const { t, i18n } = useTranslation(["timeslotCollector"]);
  const { addToast } = useToasts();

  return useMutation(timeslotCollectorService.createTimeslotCollector, {
    retry: 0,
    onSuccess: data => {
      addToast(
        t("message.create", {
          target: t("timeslot"),
          status: t("message.success"),
        }),
        {
          appearance: "success",
          autoDismiss: true,
        }
      );
      if (typeof onSuccess === "function") {
        onSuccess(data);
      }
    },
    onError: error => {
      const errorResponse = errorMessage(error);
      addToast(
        formConvertErrorMessage(
          errorResponse.message ||
            t("message.create", {
              target: t("timeslot"),
              status: t("message.error"),
            }),
          t
        ),
        {
          appearance: "error",
          autoDismiss: true,
        }
      );
      if (typeof onError === "function") {
        onError(errorResponse);
      }
    },
  });
};

export const useUpdateTimeslotCollector = (onSuccess, onError) => {
  const { t, i18n } = useTranslation(["timeslotCollector"]);
  const { addToast } = useToasts();

  return useMutation(timeslotCollectorService.updateTimeslotCollector, {
    retry: 0,
    onSuccess: data => {
      addToast(
        t("message.update", {
          target: t("timeslot"),
          status: t("message.success"),
        }),
        {
          appearance: "success",
          autoDismiss: true,
        }
      );
      if (typeof onSuccess === "function") {
        onSuccess(data);
      }
    },
    onError: error => {
      const errorResponse = errorMessage(error);
      addToast(
        formConvertErrorMessage(
          errorResponse.message ||
            t("message.update", {
              target: t("timeslot"),
              status: t("message.error"),
            }),
          t
        ),
        {
          appearance: "error",
          autoDismiss: true,
        }
      );
      if (typeof onError === "function") {
        onError(errorResponse);
      }
    },
  });
};

export const useUpdateStatusTimeslotCollector = (onSuccess, onError) => {
  const { t, i18n } = useTranslation(["timeslotCollector"]);
  const { addToast } = useToasts();

  return useMutation(timeslotCollectorService.updateStatusTimeslotCollector, {
    retry: 0,
    onSuccess: data => {
      addToast(
        t("message.update", {
          target: t("timeslot"),
          status: t("message.success"),
        }),
        {
          appearance: "success",
          autoDismiss: true,
        }
      );
      if (typeof onSuccess === "function") {
        onSuccess(data);
      }
    },
    onError: error => {
      const errorResponse = errorMessage(error);
      addToast(
        formConvertErrorMessage(
          errorResponse.message ||
            t("message.update", {
              target: t("timeslot"),
              status: t("message.error"),
            }),
          t
        ),
        {
          appearance: "error",
          autoDismiss: true,
        }
      );
      if (typeof onError === "function") {
        onError(errorResponse);
      }
    },
  });
};

export const useTimeSlotsCollectorSchedule = (payload, onSuccess, onError) => {
  const { addToast } = useToasts();
  const { t } = useTranslation(["common"]);

  return useQuery(
    ["time-slots-schedule", payload?.key ?? "all"],
    () => timeslotCollectorService.getTimeSlotsSchedule(payload),
    {
      enabled: true,
      retry: 1,
      refetchOnWindowFocus: false,
      onSuccess,
      onError: error => {
        const errorResponse = errorMessage(error);
        addToast(
          formConvertErrorMessage(
            errorResponse.message ||
              t("message.fetch_time_slot", {
                status: t("message.error"),
              }),
            t
          ),
          {
            appearance: "error",
            autoDismiss: true,
          }
        );
        if (typeof onError === "function") {
          onError(errorResponse);
        }
      },
      initialData: [],
      select: response => {
        return (
          response?.data?.map(item => {
            return {
              value: item.id,
              label: item.name,
            };
          }) || []
        );
      },
    }
  );
};
